import { useState, useEffect } from 'react';
import { Box, Grid, Button, Typography, TextField, CircularProgress, Paper, Avatar, Stack, Chip, LinearProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { updateUserProfileAPI } from 'api/IdentityServiceAPI';
import { setAppuserInfo, setuserprofileInfo } from 'store/slice/HeaderSlice';

export default function ProfileMgmt(){
    const dispatch = useDispatch();
    const { userprofileInfo, appuserInfo } = useSelector((state)=>state.headerslice);
    const [editMode, setEditMode] = useState(false);
    const [name, setName] = useState(userprofileInfo.username || userprofileInfo.name || appuserInfo.name || '');
    const [mobileNumber, setMobileNumber] = useState(appuserInfo.mobile || userprofileInfo.mobileNumber || userprofileInfo.mobile || '');
    const [apiInProgress, setApiInProgress] = useState(false);

    useEffect(() => {
        if (editMode) return;
        setName(userprofileInfo.username || userprofileInfo.name || appuserInfo.name || '');
        setMobileNumber(appuserInfo.mobile || userprofileInfo.mobileNumber || userprofileInfo.mobile || '');
    }, [userprofileInfo, appuserInfo, editMode]);

    const initiEdit = () =>{
        setEditMode(true);
    }
    const cancelEdit = () => {
        setName(userprofileInfo.username || userprofileInfo.name || appuserInfo.name || '');
        setMobileNumber(appuserInfo.mobile || userprofileInfo.mobileNumber || userprofileInfo.mobile || '');
        setEditMode(false);
    };
    
    const setProfileValue = (e) => {
        const {name, value} = e.target;
        if (name === 'name') {
            setName(value);
        }
        if (name === 'mobileNumber') {
            setMobileNumber(value.replace(/\D/g, '').slice(0, 11));
        }
    }
    const saveProfileSuccess = () =>{
        setEditMode(false);
        setApiInProgress(false);
        dispatch(setAppuserInfo({
            ...appuserInfo,
            name,
            mobile: mobileNumber
        }));
        dispatch(setuserprofileInfo({
            ...userprofileInfo,
            username: name,
            name,
            mobileNumber,
            mobile: mobileNumber
        }));
    }
    const saveProfileFailure = (errMsg) =>{
        setApiInProgress(false);
        console.log('!! ERROR !! =>'+errMsg);
    }
    const saveProfile = () =>{
        if (!name?.trim() || !mobileNumber?.trim()) return;
        setApiInProgress(true);
        updateUserProfileAPI({
            "name": name.trim(),
            "mobileNumber": mobileNumber
            },saveProfileSuccess, saveProfileFailure
        )
    }
    return (
        <Box sx={{ p: { xs: 1, md: 2 } }}>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'divider',
                    overflow: 'hidden',
                    background: 'linear-gradient(180deg, #f8fbff 0%, #ffffff 40%)'
                }}
            >
                {apiInProgress ? <LinearProgress /> : null}
                <Box sx={{ p: { xs: 2, md: 3 } }}>
                    {!editMode ? (
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', md: 'center' }}>
                            <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56 }}>
                                <PersonOutlineIcon />
                            </Avatar>
                            <Box>
                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                    {userprofileInfo.username || userprofileInfo.name || appuserInfo.name || '-'}
                                </Typography>
                                <Chip
                                    icon={<PhoneAndroidIcon />}
                                    label={appuserInfo.mobile || userprofileInfo.mobileNumber || userprofileInfo.mobile || '-'}
                                    sx={{ mt: 1, fontWeight: 500 }}
                                />
                            </Box>
                        </Stack>
                    ) : (
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Enter your name"
                                    required
                                    label="Your Name"
                                    name="name"
                                    value={name}
                                    onChange={setProfileValue}
                                    disabled={apiInProgress}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Enter mobile number"
                                    required
                                    label="Mobile Number"
                                    name="mobileNumber"
                                    value={mobileNumber}
                                    onChange={setProfileValue}
                                    disabled={apiInProgress}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Stack direction="row" spacing={1.5} justifyContent="flex-end">
                                    <Button variant="text" onClick={cancelEdit} disabled={apiInProgress}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={saveProfile}
                                        disabled={apiInProgress || !name?.trim() || !mobileNumber?.trim()}
                                        startIcon={apiInProgress ? <CircularProgress size={16} color="inherit" /> : null}
                                    >
                                        {apiInProgress ? 'Saving...' : 'Save'}
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    )}
                </Box>
            </Paper>
            {!editMode ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                    <Button variant="outlined" startIcon={<EditIcon />} onClick={initiEdit}>
                        Edit Profile
                    </Button>
                </Box>
            ) : null}
        </Box>
    )
}
